// oxlint-disable-next-line endla/no-compiler-opt-out -- Existing code
"use no memo";

import { useMemo, useState } from "react";

export type DialogState = {
  isOpen: boolean;
  openDialog: () => void;
  closeDialog: () => void;
  onOpenChange: (nextIsOpen: boolean) => void;
};

export function useDialog(): DialogState {
  const [isOpen, setIsOpen] = useState(false);

  return useMemo(() => {
    function openDialog() {
      setIsOpen(true);
    }

    function closeDialog() {
      setIsOpen(false);
    }

    function onOpenChange(nextIsOpen: boolean) {
      setIsOpen(nextIsOpen);
    }

    return {
      isOpen,
      openDialog,
      closeDialog,
      onOpenChange,
    };
  }, [isOpen]);
}
